import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Grid, Tab } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabPanel from '@material-ui/lab/TabPanel';
import { isEmpty } from 'lodash';
import PieCharts from '../components/PieCharts';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import '../../AnsweKeyResponses/styles.scss';
import { Skeleton, TabList } from '@material-ui/lab';

export default function SubjectTable(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const [value, setValue] = React.useState('0');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const populateTab = () => {
    const list = [];
    (props.isFetching ? [1, 1, 1] : props.subjectsData).map((data, index) => {
      list.push(
        <Tab
          label={
            props.isFetching ? <Skeleton width="50px" /> : data.SubjectName
          }
          value={index.toString()}
        />
      );
    });
    return list;
  };

  const TableComp = (item) => {
    const list = [];
    (props.isFetching
      ? [1, 1, 1, 1, 1, 1, 1, 1]
      : item.listQuestion
      ? item.listQuestion
      : []
    ).map((data, index) => {
      list.push(
        <TableRow key={index}>
          <TableCell component="th" scope="row">
            {props.isFetching ? <Skeleton width="50px" /> : item.QStart + index}
          </TableCell>
          <TableCell
            className={data.Score < 0 ? 'MuiTableCell-body' : ''}
            align="right"
          >
            <pre>
              {props.isFetching ? (
                <Skeleton width="50px" />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.CorrectAnswer,
                  }}
                  className="height-100"
                />
              )}
            </pre>
          </TableCell>
          <TableCell align="right">
            <pre>
              {' '}
              {props.isFetching ? (
                <Skeleton width="50px" />
              ) : data.Marked === 'Not Attempted' ? (
                'NA'
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.Marked,
                  }}
                  className="height-100"
                />
              )}
            </pre>
          </TableCell>
          <TableCell align="right" style={{ paddingRight: '18px' }}>
            <span
              style={{
                color:
                  data.Score > 0
                    ? '#0FDE00'
                    : data.Score < 0
                    ? '#FF0000'
                    : '#FFA304',
              }}
            >
              {props.isFetching ? <Skeleton width="50px" /> : data.Score}
            </span>
          </TableCell>
        </TableRow>
      );
    });

    // For Scroll only in desktop
    const MyScrollBar = matches === true ? PerfectScrollbar : 'div';

    return (
      <TableContainer className="table-container answer-table">
        <MyScrollBar>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  {props.isFetching ? <Skeleton width="50%" /> : 'Q.No'}{' '}
                </TableCell>
                <TableCell align="right">
                  {props.isFetching ? (
                    <Skeleton width="50%" />
                  ) : (
                    'Correct Answer'
                  )}
                </TableCell>
                <TableCell align="right">
                  {props.isFetching ? (
                    <Skeleton width="50%" />
                  ) : (
                    'Your Response'
                  )}
                </TableCell>
                <TableCell align="right">
                  {props.isFetching ? <Skeleton width="50%" /> : 'Score'}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{list}</TableBody>
          </Table>
        </MyScrollBar>
      </TableContainer>
    );
  };

  return (
    <React.Fragment>
      {(props.isFetching || !isEmpty(props.subjectsData)) && (
        <div className="tab-design">
          <TabContext value={value}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              className="line-tab"
            >
              {(props.isFetching || props.subjectsData.length > 0) &&
                populateTab()}
            </TabList>
            <div className="answer-slider">
              <TabPanel value={value.toString()}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={5}>
                    {props.isFetching ? (
                      <Skeleton variant="circle" width={250} height={250} />
                    ) : (
                      <PieCharts data={props.subjectsData[value]} />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12} md={7}>
                    {TableComp(props.subjectsData[value])}
                  </Grid>
                </Grid>
              </TabPanel>
            </div>
          </TabContext>
        </div>
      )}
    </React.Fragment>
  );
}
SubjectTable.propTypes = {
  subjectsData: PropTypes.object,
  listQuestion: PropTypes.object,
  QStart: PropTypes.number,
  isFetching: PropTypes.bool,
};
